/**
 * Project mapaya-client
 *
 * Created by stefensuhat on 30/07/18 11.19 AM
 */

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fab,
    Slide,
    Typography,
    withStyles,
    withMobileDialog,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import cx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import LoadingButton from './LoadingButton';

const styles = ({ spacing }) => ({
    root: {},
    title: {
        borderBottom: 0,
        marginBottom: 0,
        padding: spacing(2, 3, 0),
    },
    content: {
        borderBottom: 0,
        padding: spacing(1, 3),
    },
    close: {
        marginBottom: spacing(3),
    },
    action: {
        padding: spacing(0, 3),
        borderTop: 0,
    },
    mobileAction: {
        justifyContent: 'flex-start',
        margin: 0,
        marginTop: spacing(2),
        paddingBottom: spacing(3),
    },
});

const propTypes = { loading: PropTypes.bool };
const defaultProps = { loading: false };

const mapStateToProps = ({ alertDialog }) => ({
    payload: alertDialog.content,
    loading: alertDialog.loading,
});

const mapDispatchToProps = ({ alertDialog }) => ({
    remove: () => alertDialog.remove(),
});

function TransitionComponent(props) {
    return <Slide direction="up" {...props} />;
}

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);

class AlertDialog extends Component {
    state = { open: false, payload: {}, showCloseAction: true };

    static getDerivedStateFromProps(props) {
        if (props.payload) {
            const { payload: { showCloseAction } } = props;

            let closeAction = true;
            if (typeof showCloseAction === 'undefined') {
                closeAction = true;
            } else {
                closeAction = showCloseAction;
            }

            return { open: true, payload: props.payload, showCloseAction: closeAction };
        }

        return { open: false, payload: {}, showCloseAction: true };
    }

    componentDidUpdate(prevProps) {
        const { location, remove } = this.props;

        if (location !== prevProps.location) {
            if (location.pathname !== prevProps.location.pathname) {
                remove();
            }
        }

        return null;
    }

    handleClose = () => {
        const { remove } = this.props;
        const { payload: { onClose } } = this.state;

        remove();
        if (typeof onClose === 'function') {
            onClose();
        }
    };


    render() {
        const { loading, classes, fullScreen } = this.props;
        const { open, payload, showCloseAction } = this.state;
        const { title, content, actions, closeLabel } = payload;

        return (
            <Dialog
                fullWidth
                fullScreen={fullScreen}
                maxWidth="sm"
                open={open}
                aria-describedby={title}
                classes={{ paper: classes.root }}
                disableBackdropClick
                onClose={this.handleClose}
                onEscapeKeyDown={this.handleClose}
                TransitionComponent={TransitionComponent}
            >
                <DialogTitle disableTypography className={classes.title}>

                    <Fab size="small" color="default" className={classes.close} onClick={this.handleClose}>
                        <CloseIcon />
                    </Fab>

                    <Typography variant="h5">{title || ''}</Typography>

                </DialogTitle>

                <DialogContent className={classes.content}>
                    {React.isValidElement(content)
                        ? content : (
                            <DialogContentText>
                                <Typography variant="subtitle1">{content}</Typography>
                            </DialogContentText>
                        )}
                </DialogContent>

                <DialogActions className={cx(classes.action, classes.mobileAction)}>
                    {showCloseAction
                    && (
                        <Button type="button" variant="contained" color="secondary" onClick={this.handleClose}>
                            {closeLabel || 'Close'}
                        </Button>
                    )}

                    {actions && actions.map(({
                        color, variant, label, onClick,
                    }) => (
                        <LoadingButton
                            key={label}
                            loading={loading}
                            color={color || 'primary'}
                            variant={variant || 'outlined'}
                            onClick={onClick}
                        >
                            {label}
                        </LoadingButton>

                    ))}
                </DialogActions>
            </Dialog>
        );
    }
}

AlertDialog.propTypes = propTypes;
AlertDialog.defaultProps = defaultProps;

export default compose(withStyles(styles, { name: 'AlertDialog' }), withMobileDialog(), reduxConnector)(
    AlertDialog,
);
